<template>
    <PerfectScrollbar class="AllPwaMobile">
      <header-menu></header-menu>

      <div style="grid-template-columns: 50% 50%;" class="AllPwaMobileClass">
        <!-- <div @click="styleMenu(3)" :style="style3" class="ChildAllPwaMobileClass">
            {{ $t('transaction.transfer') }}
        </div> -->
        <div @click="styleMenu(2)" :style="style2" class="ChildAllPwaMobileClass">
            {{ $t('transaction.paid') }}
        </div>
        <div @click="styleMenu(1)" :style="style1" class="ChildAllPwaMobileClass">
            {{ $t('transaction.received') }}
        </div>
      </div>


      <div class="ShowIconVsxIcon" v-if="BtnSvue == 1">
        <div @click="SearchClick(SearchLists , 'd')" class="ShowSearchLists" v-for="(SearchLists,index) in depositList"  :key="index">
            <div class="ShowPriceSearchT">
              <span style="color: #70ea70">
                <span style="font-size: 1rem">{{formatCurrency(SearchLists.total_debited || SearchLists.amount)}}</span> <span style="font-size: .7rem">{{ SearchLists.currency || 'USD' }}</span>
              </span>
              <p>{{SearchLists.gateway.name}}</p>
            </div>

            <div :style="getStyle(SearchLists.status)" style=" margin-bottom: 10px" class="DotShowPriceSearchT"></div>

            <div style="margin-bottom: 0" class="ShowPriceSearchT">
              <span>{{SearchLists.trx}}</span>

              <div v-if="SearchLists.status == 1" class="ShowImageClassDiv">
                <VsxIcon iconName="Forbidden" :size="32" color="#ff7373" type="linear" />
              </div>
              <div v-if="SearchLists.status == 3" class="ShowImageClassDiv">
                <VsxIcon iconName="TickCircle" :size="32" color="#70ea70" type="linear" />
              </div>
              <div v-if="SearchLists.status == 2" class="ShowImageClassDiv">
                <VsxIcon iconName="Celsius" :size="32" color="orange" type="linear" />
              </div>
            </div>
        </div>
      </div>
      <div class="ShowIconVsxIcon" v-if="BtnSvue == 2">
        <div @click="SearchClick(SearchLists , 'w')" class="ShowSearchLists" v-for="(SearchLists,index) in widList"  :key="index">
          <div class="ShowPriceSearchT">
              <span style="color: #70ea70">
                <span style="font-size: 1rem">{{formatCurrency(SearchLists.amount)}}</span> <span style="font-size: .7rem">{{ SearchLists.currency || 'USD' }}</span>
              </span>
            <p>{{SearchLists.method.name}}</p>
          </div>

          <div :style="getStyle(SearchLists.status)" style=" margin-bottom: 10px" class="DotShowPriceSearchT"></div>

          <div style="margin-bottom: 0" class="ShowPriceSearchT">
            <span>{{SearchLists.trx}}</span>

            <div v-if="SearchLists.status == 1" class="ShowImageClassDiv">
              <VsxIcon iconName="Forbidden" :size="32" color="#ff7373" type="linear" />
            </div>
            <div v-if="SearchLists.status == 3" class="ShowImageClassDiv">
              <VsxIcon iconName="TickCircle" :size="32" color="#70ea70" type="linear" />
            </div>
            <div v-if="SearchLists.status == 2" class="ShowImageClassDiv">
              <VsxIcon iconName="Celsius" :size="32" color="orange" type="linear" />
            </div>
          </div>
        </div>
      </div>
      <div class="ShowIconVsxIcon" v-if="BtnSvue == 3">
        <p>{{ $t('transaction.transfer') }}</p>
      </div>

      <div @click="ModelList = false" v-if="ModelList" class="ModelShowIconToUserSpan">
        <div @click.stop style="padding: 10px" class="TableModelShowIconToUserSpan">
          <template v-if="status === 'w'">
            <div class="SpanTableModelShowIconToUserSpan">
              <span>{{ formatCurrency(ModelList.amount) }} {{ ModelList.currency || 'USD' }}</span>
              <p>{{ $t('transaction.details.requestedAmount') }}</p>
            </div>

            <div class="SpanTableModelShowIconToUserSpan">
              <span>{{ formatCurrency(ModelList.fee_amount || 0) }} {{ ModelList.currency || 'USD' }} ({{ formatPercent(ModelList.fee_percent) }}%)</span>
              <p>{{ $t('transaction.details.fee') }}</p>
            </div>

            <div class="SpanTableModelShowIconToUserSpan">
              <span>{{ formatCurrency(ModelList.total_debited || ModelList.amount) }} {{ ModelList.currency || 'USD' }}</span>
              <p>{{ $t('transaction.details.totalDeducted') }}</p>
            </div>

            <div v-if="Number(ModelList.refunded_amount || 0) > 0" class="SpanTableModelShowIconToUserSpan">
              <span>{{ formatCurrency(ModelList.refunded_amount) }} {{ ModelList.currency || 'USD' }}</span>
              <p>{{ $t('transaction.details.refundedAmount') }}</p>
            </div>
          </template>

          <template v-else>
          <div style="display: grid; grid-template-columns: auto auto; justify-content: space-between; align-items: center" class="SpanTableModelShowIconToUserSpan">
            <span>{{formatCurrency(ModelList.charge)}} {{ ModelList.currency || 'USD' }}</span>
            <p>{{ $t('transaction.details.fee') }}</p>
          </div>

          <div style="display: grid; grid-template-columns: auto auto; justify-content: space-between; align-items: center" class="SpanTableModelShowIconToUserSpan">
            <span>{{ formatCurrency(ModelList.amount + ModelList.charge) }} {{ ModelList.currency || 'USD' }}</span>
            <p>{{ $t('transaction.details.depositWithFee') }}</p>
          </div>

          <div class="SpanTableModelShowIconToUserSpan">
            <p>{{ $t('transaction.details.conversion') }}</p>

            <span v-if="status == 'w'" class="value">{{ formatCurrency(ModelList.amount - ModelList.charge) }} x {{ formatCurrency(ModelList.rate) }} = {{ formatCurrency(ModelList.final_amount) }}</span>

            <span v-if="status == 'd'" class="value">{{ formatCurrency(ModelList.amount + ModelList.charge) }} x {{ formatCurrency(ModelList.rate) }}  = {{ formatCurrency(ModelList.final_amo) }}</span>
          </div>
          </template>

          <div style="display: grid; grid-template-columns: auto auto; justify-content: space-between; align-items: center" class="SpanTableModelShowIconToUserSpan">
            <span v-if="ModelList.status == 2">{{ $t('transaction.status.pending') }}</span>
            <span v-if="ModelList.status == 1">{{ $t('transaction.status.rejected') }}</span>
            <span v-if="ModelList.status == 3">{{ $t('transaction.status.approved') }}</span>
            <p>{{ $t('transaction.details.status') }}</p>
          </div>
        </div>
      </div>

      <menu-bar></menu-bar>
    </PerfectScrollbar>
</template>
<script>
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import axios from "@/axios";
// import {toast} from "vue3-toastify";

  export default {
    name: 'transactionUser',
    components: {
      PerfectScrollbar,
    },
    data(){
      return{
        color: "",
        style3: "",
        style2: "",
        style1: "border-bottom: 2px solid #BB86FC;",
        BtnSvue: 1,
        depositList: [],
        widList: [],
        OpenModel: false,
        ModelList: false,
        status: '',
      }
    },
    methods:{
      SearchClick(value , value1){
        this.ModelList = []
        this.OpenModel = true
        this.ModelList = value
        this.status = value1
      },
      getStyle(status) {
        switch (status) {
          case 1:
            return { border: '1px dashed red' };
          case 2:
            return { border: '1px dashed orange' };
          case 3:
            return { border: '1px dashed green' };
          default:
            return {};
        }
      },
      formatCurrency(value) {
        const numberValue = parseFloat(value);
        if (isNaN(numberValue)) {
          return 'Invalid amount';
        }
        return numberValue.toLocaleString();
      },
      formatPercent(value) {
        const numberValue = Number(value || 0);
        return Number.isFinite(numberValue) ? numberValue.toLocaleString(undefined, { maximumFractionDigits: 4 }) : '0';
      },
      styleMenu(value){
            this.BtnSvue = value

            if(value === 1){
                this.style3 = ""
                this.style2 = ""
                this.style1 = "border-bottom: 2px solid #BB86FC;"
            }
            if(value === 2){
                this.style3 = ""
                this.style2 = "border-bottom: 2px solid #BB86FC;"
                this.style1 = ""
            }
            if(value === 3){
                this.style3 = "border-bottom: 2px solid #BB86FC;"
                this.style2 = ""
                this.style1 = ""
            }
        },
      loadTheme() {
        const savedTheme = localStorage.getItem('theme');
        if( savedTheme == "light"){
          this.color = '#2E1977'
        }else{
          this.color = '#BB86FC'
        }
      },
      async DataUpdateUser(){
        const userData = localStorage.getItem('user');
        const userData1 = JSON.parse(userData);

        let attempts = 0;
        const maxAttempts = 10;
        const delay = 100;
        while (attempts < maxAttempts) {
          try {
            const response = await axios.post('/withdraw-user' , {
              user_id : userData1.id
            });

            if (response.data[0] === "success"){
              this.depositList = response.data[1][1].data
              this.widList = response.data[1][0].data
            }

            return;
          } catch (error) {
            if (error.response && error.response.status === 500) {
              console.error('Server error 500: Stopping further attempts.');
            }
          }

          attempts++;
          await new Promise(resolve => setTimeout(resolve, delay));
        }
      }
    },
    mounted(){
      this.DataUpdateUser()
      setInterval(() => {
        this.loadTheme()
      }, 100);
    }
  }
</script>

<style scoped>
</style>
  
  